<template>
  <div>
      <video-player class="video-player vjs-custom-skin" ref="videoPlayer" name="videoPlayer" id="video" :playsinline="true"
        :options="playerOptions" @play="onPlayerPlay($event)" @pause="onPlayerPause($event)"
        @ended="onPlayerEnded($event)" @waiting="onPlayerWaiting($event)" @timeupdate="onPlayerTimeupdate($event)"
        @statechanged="playerStateChanged($event)" @canplaythrough="onPlayerCanplaythrough($event)" @ready="playerReadied"></video-player>
  </div>
</template>
<script>
import { videoPlayer } from "vue-video-player";
import "video.js/dist/video-js.css";
import "vue-video-player/src/custom-theme.css";
export default {
  name: '',
  components: {
    videoPlayer
  },
  data() {
    return {
      playTime: '',
      current: '',
      globalSetting: {},
      playerOptions: {
        playbackRates: [], // 可选的播放速度
        autoplay: true, // 如果为true,浏览器准备好时开始回放。
        muted: true, // 默认情况下将会消除任何音频。
        loop: true, // 是否视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          type: "video/mp4", // 类型
          src: "https://images.cardhobby.com/2023ASCC.mp4" // url地址
          //src: "/static/video/20220803_102954.mp4" // url地址
        }],
        poster: "", // 封面地址
        notSupportedMessage: "此视频暂无法播放，请稍后再试", // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        //controlBar: false
        controlBar: {
          playToggle:false,
          currentTimeDisplay:false,//进行时间
          progressControl:false,//进度条
          timeDivider: false, // 当前时间和持续时间的分隔符
          durationDisplay: false, // 显示持续时间
          remainingTimeDisplay: false, // 是否显示剩余时间功能
          fullscreenToggle: false // 是否显示全屏按钮
        },
      },
    };
  },
  beforeRouteLeave() {
    //this.$refs.videoPlayer.player.pause()
  },
  mounted(){
    this.pauseVideo()

  },
  methods: {

    pauseVideo(){
      let that=this
      setTimeout(function () { 
      that.$refs.videoPlayer.player.pause()
      }, 30 * 1000 * 60); 
      //30分钟暂停
    },

    // 播放回调
    onPlayerPlay(player) {
      //console.log("player play!", player);
    },

    // 暂停回调
    onPlayerPause(player) {
      //console.log("player pause!", player);
    },

    // 视频播完回调
    onPlayerEnded($event) {
      //$event.play()
      //console.log(player);
    },
    // DOM元素上的readyState更改导致播放停止
    onPlayerWaiting(player) {
      // let time = localStorage.getItem("cacheTime")
      // if (player.cache_.currentTime - Number(time) > 0.1) {
      //   this.current = Number(time)
      //   this.playerReadied(player)
      // } else {
      //   this.current = player.cache_.currentTime
      // }
    },

    // 已开始播放回调
    onPlayerPlaying($event) {
      // console.log(player)
    },

    // 当播放器在当前播放位置下载数据时触发
    onPlayerLoadeddata($event) {
      // console.log(player)
    },

    // // 当前播放位置发生变化时触发。
    onPlayerTimeupdate(player) {
      // this.playTime = player.cache_.currentTime
      // let playTime = player.cache_.currentTime
      // setTimeout(function() {
      //   localStorage.setItem("cacheTime", playTime)
      // }, 500)


      // let time = localStorage.getItem("cacheTime")
      // if (player.cache_.currentTime - Number(time) > 2) {
      //   this.current = Number(time)
      //   this.playerReadied(player)
      // } else {
      //   this.current = player.cache_.currentTime
      // }
    },

    //媒体的readyState为HAVE_FUTURE_DATA或更高
    onPlayerCanplay(player) {
      // console.log('player Canplay!', player)
    },

    //媒体的readyState为HAVE_ENOUGH_DATA或更高。这意味着可以在不缓冲的情况下播放整个媒体文件。
    onPlayerCanplaythrough(player) {
      // console.log('player Canplaythrough!', player)
    },

    //播放状态改变回调
    playerStateChanged(playerCurrentState) {
      // console.log('player current update state', playerCurrentState)
    },

    //将侦听器绑定到组件的就绪状态。与事件监听器的不同之处在于，如果ready事件已经发生，它将立即触发该函数。。
    playerReadied(player) {
      // console.log('example player 1 readied', player);
      // player.currentTime(this.current)
//       this.$nextTick(() => {
//         this.playerOptions.muted = false;
//         //this.$refs.videoPlayer.player.play()
// })
    }
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.video-js:hover .vjs-big-play-button,
.vjs-custom-skin > .video-js .vjs-big-play-button:focus,
.vjs-custom-skin > .video-js .vjs-big-play-button:active,
.vjs-custom-skin > .video-js .vjs-big-play-button {
  display: none;
}
.vjs-control-bar {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/video.vue